<template>
  <div>
    <div v-if="notes" class="overlay">
      <b-row class="justify-content-center align-items-center scanner-input">
        <b-col sm="12" md="4" class="p-4 bg-dark text-center text-dark rounded">
          <b-form-select v-model="currentNotes.noteType" :options="noteTypes" class="mb-3"></b-form-select>
          <b-form-textarea v-model="currentNotes.notes"></b-form-textarea>
          <b-row class="mt-3">
            <b-col cols="6">
              <b-button
                @click="closeNotes"
                variant="secondary"
                block size="lg">
                CLOSE
              </b-button>
            </b-col>
            <b-col cols="6">
              <b-button
                @click="saveNotes"
                variant="primary"
                block size="lg">
                SAVE
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <div v-if="scanner" class="row pb-3 border-bottom border-danger">
      <div class="w-100 text-center mt-3">
        <h3>SCANNING {{scanLocal ? 'LOCAL' : 'POLAND'}} BOXES</h3>
      </div>
      <div class="w-20 mt-4">
        <button class="btn-primary px-5 py-2 text-uppercase">Handheld Scanner Active</button>
      </div>
      <div class="w-20 mt-4 ml-3">
        <button @click="closeScanner" class="btn btn-danger px-5 py-2">
          CLOSE SCANNER <b-icon-file-break shift-h="10"></b-icon-file-break>
        </button>
      </div>
    </div>
    <div v-else class="row pb-3 border-bottom border-danger">
      <div class="w-100 text-center mt-3 mb-4">
        <h3>PROCESSING ORDERS</h3>
      </div>

      <!--        <div class="w-20">-->
      <!--          <b-form-input-->
      <!--            class="bg-dark text-white"-->
      <!--            v-model="search"-->
      <!--            :disabled="!data.length"-->
      <!--            placeholder="SKU FILTER"></b-form-input>-->
      <!--        </div>-->
      <div class="col">
        <button @click="setFilter('ready')" class="btn btn-success mr-2 py-2">READY TO CLOSE</button>
        <button @click="setFilter('regos')" class="btn btn-warning mr-2 py-2">LOCAL FOR REGOS</button>
      </div>
      <div class="col">
        <button @click="startScanner(false)" class="btn btn-primary py-2" :disabled="!data.length">
          SCAN POLAND <b-icon-file-break shift-h="0"></b-icon-file-break>
        </button>
        <button @click="startScanner(true)" class="btn btn-info py-2 mx-2" :disabled="!data.length">
          SCAN LOCAL <b-icon-file-break shift-h="0"></b-icon-file-break>
        </button>
      </div>
      <div class="w-30">
        <button class="btn btn-success p-2 float-right">
          TOTAL VALUE: {{totalPrice.toFixed(2).toLocaleString('en')}} PLN ({{totalCount}} pcs)
        </button>
      </div>
    </div>
    <div v-if="loading" class="overlay">
      <div class="w-100 position-absolute text-center" style="top: 50%; transform: translateY(-50%);">
        <b-icon class="text-white" icon="arrow-clockwise" animation="spin" font-scale="3"></b-icon>
      </div>
    </div>

    <div v-if="data.length">
      <div class="row mt-3 overflow-auto">
        <div class="w-100">
          <table class="table" ref="articles">
            <thead>
            <tr>
              <th scope="col">#</th>
              <!--              <th scope="col">Added</th>-->
              <!--              <th scope="col">SKU</th>-->
              <th class="d-none d-sm-table-cell" scope="col">SSKU</th>
              <!--              <th class="d-none d-sm-table-cell" scope="col">Factory #</th>-->
              <th class="d-none d-sm-table-cell" scope="col">Name</th>
              <th class="d-none d-sm-table-cell" scope="col">Ordered</th>
              <th class="d-none d-sm-table-cell" scope="col">Scanned</th>
              <th class="d-none d-sm-table-cell text-center" scope="col">Ordered For</th>
              <th class="d-none d-sm-table-cell" scope="col">Notes</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(row, i) of filteredList">
              <!-- Date header row: print only when date changes, always before separator and order row -->
              <tr
                v-if="i === 0 || moment.utc(row.addedAt).format('YYYY-MM-DD') !== moment.utc(filteredList[i-1].addedAt).format('YYYY-MM-DD')"
                :key="'date-' + moment.utc(row.addedAt).format('YYYY-MM-DD') + '-' + i"
                style="border-top: 35px solid #222222 !important;"
              >
                <td colspan="10" class="bg-primary text-white text-center font-weight-bold" style="font-size: 1.3em;">
                  {{ moment.utc(row.addedAt).format('DD.MM.YYYY') }}
                </td>
              </tr>
              <!-- Separator row for metaData group -->
              <tr v-if="row.border" class="separator" :key="'sep-' + i">
                <td @click="closePackage(!!row.fromWeb, row.metaData, row.addedAt, getBoxIdForMetadata(row.metaData))"
                    class="bg-success pointer" v-if="allConfirmed(row)"
                >
                  <b-icon-box-seam animation="pulse" />
                </td>
                <td colspan="9" :class="[getClassForMetadata(row), 'w-100']">
                    <span
                      @click="printLabelForAny(row)"
                      class="text-uppercase" style="cursor: pointer"
                      v-b-tooltip.hover.right="`Ordered: ${moment.utc(row.addedAt).format('DD.MM.YYYY HH:mm')} UTC`">
                      {{row.fromWeb ? 'website' : row.user && row.user.username || 'Lyngdal'}} - {{row.metaData}} {{row.packingBox ? `[${row.packingBox.boxName}]` : ''}}
                    </span>
                  <span
                    @click="openBoxAssignment(row)"
                    class="ml-3 box-action-icon"
                    v-b-tooltip.hover.left="row.packingBox ? 'Change box assignment' : 'Assign packing box'">
                    <b-icon :icon="row.packingBox ? 'tags-fill' : 'tag'" :font-scale="1.1"></b-icon>
                  </span>
                  <span v-if="row.fromWeb && row.deliveryMethod" class="ml-3 float-right">{{row.deliveryMethod.name}}</span>
                </td>
              </tr>
              <!-- Order row -->
              <tr :key="i" :class="['article-row', row.border ? `${getRowClass(row)}` : getRowClass(row), i === scannedRowIndex ? 'highlighted-row' : '']">
                <td>{{i+1}}</td>
                <td>{{row.ssku}}</td>
                <td>{{row.name}}</td>
                <!--                  <td>{{row.ssku}}</td>-->
                <!--                  <td>{{row.num}}</td>-->
                <td class="text-center">{{row.count}} - {{!row.processed ? 'O' : (row.replacedWithLocal ? 'L' : 'P')}}
                  <br v-if="row.replacedWithLocal && row.lastLocation">{{row.lastLocation}}
                </td>
                <td class="text-center">{{row.confirmed || 0}}</td>
                <td class="text-center">{{row.metaData || 'WORKSHOP'}}</td>
                <td v-b-tooltip.hover.left="row.notes ? stripHtmlTags(row.notes) : ''" class="text-center" @click="openNotes(row)">
                  <b-icon icon="pencil-square" class="pointer"></b-icon>
                </td>
              </tr>
            </template>

            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-else-if="!data.length && !loading" class="text-center mt-3">
      <h5>All orders processed ☑️</h5>
    </div>

    <b-modal
      id="box-select-modal"
      :title="currentBoxMetadata.currentBox ? 'Change Packing Box 📦' : 'Select Packing Box 📦'"
      @ok="handleBoxSelection"
      ok-title="Select">
      <div v-if="currentBoxMetadata.currentBox" class="mb-3 p-2 bg-warning text-dark rounded">
        <strong>Current Box:</strong> {{ currentBoxMetadata.currentBox }}
      </div>
      <b-form-select
        v-model="selectedBox"
        :options="boxOptions"
        value-field="id"
        text-field="boxName"
        disabled-field="disabled"
        class="mb-3">
        <template #first>
          <b-form-select-option :value="null">Please select available box...</b-form-select-option>
        </template>
      </b-form-select>
    </b-modal>

  </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';

import { metadataMapping } from '@/utils';
import { clientDataSticker, packageSticker } from '@/sticker';
import fixed from '../fixed';

export default {
  components: {
  },
  data: () => ({
    loading: false,
    data: [],
    totalCount: 0,
    totalPrice: 0,
    search: '',
    filter: null,

    notes: false,
    scanner: false,
    code: '',
    scanned: { order: '', code: '' },
    allScanned: {},
    currentNotes: {
      id: '',
      noteType: 0,
      notes: '',
    },

    printData: {},

    noteTypes: [
      { value: 0, text: 'Other' },
      { value: 1, text: 'EAN code issue' },
      { value: 2, text: 'Unavailable goods' },
      { value: 3, text: 'Goods replaced with' },
      { value: 4, text: 'Item canceled' },
    ],

    successAudio: null,
    errorAudio: null,

    scannedRowIndex: -1,
    scanBuffer: '',
    lastScanTime: 0,
    scanLocal: false, // false = poland, true = local

    packingBoxes: [],
    selectedBox: null,
    currentBoxMetadata: {
      metaData: null,
      addedAt: null,
      currentBox: null,
      currentBoxId: null,
    },
    moment,
  }),
  computed: {
    filteredList() {
      switch (this.filter) {
        case 'ready':
          return this.data.filter((row) => {
            const key = this.getCompositeKey(row);
            return this.allScanned[key] && this.allScanned[key].count === this.allScanned[key].confirmed;
          });
        case 'processing':
          return this.data.filter((row) => {
            const key = this.getCompositeKey(row);
            return this.allScanned[key] && this.allScanned[key].count !== this.allScanned[key].confirmed;
          });
        case 'regos':
          return this.data.filter((row) => {
            const isRegosOrder = row.metaData.toLowerCase().startsWith('regos_');
            const isNotFullyConfirmed = !row.confirmed || row.confirmed < row.count;

            return isRegosOrder && row.replacedWithLocal && isNotFullyConfirmed;
          });
        default:
          return this.data.filter((row) => row.sku.match(this.search));
      }
    },
    boxOptions() {
      return this.packingBoxes.reduce((acc, packing) => {
        const row = {
          id: packing.id,
          boxName: `${packing.boxName} | Size: ${packing.boxSize}`,
          disabled: false,
        };

        acc.push(row);
        return acc;
      }, []);
    },
  },
  mounted() {
    // Initial data fetch
    this.getOrders();
    // preload scan sounds
    this.initAudio();
  },
  destroyed() {
    // Clean up event listeners
    document.removeEventListener('keydown', this.handleScannerKeys);
    // Clean up audio resources
    this.successAudio = null;
    this.errorAudio = null;
  },
  methods: {
    // Helper method to generate composite key for order grouping (metaData + date)
    getCompositeKey(row) {
      const dateKey = moment.utc(row.addedAt).format('YYYY-MM-DD');
      return `${row.metaData.trim()}|${dateKey}`;
    },
    initAudio() {
      if (!this.successAudio) {
        this.successAudio = new Audio('/ok.mp3');
        this.successAudio.preload = 'auto';
      }
      if (!this.errorAudio) {
        this.errorAudio = new Audio('/error.mp3');
        this.errorAudio.preload = 'auto';
      }
    },
    async getOrders() {
      this.search = '';
      this.totalCount = 0;
      this.totalPrice = 0;
      this.loading = true;

      try {
        const { data } = await axios.get(
          `${fixed.API_URL}/poland-processing`,
          { withCredentials: true },
        );
        if (data && data.length) {
          // Group by day first using UTC to avoid timezone issues
          const groupedByDay = {};
          data.forEach((row) => {
            const day = moment.utc(row.addedAt).format('YYYY-MM-DD');
            if (!groupedByDay[day]) groupedByDay[day] = [];
            groupedByDay[day].push(row);
          });

          // Sort days in descending order (newest first)
          const sortedDays = Object.keys(groupedByDay).sort((a, b) => new Date(b) - new Date(a));

          // Process each day
          this.data = [];
          sortedDays.forEach((day) => {
            // Group by metaData within each day
            const metaGroups = {};
            groupedByDay[day].forEach((row) => {
              const meta = row.metaData ? row.metaData.trim().toLowerCase() : '';
              if (!metaGroups[meta]) metaGroups[meta] = [];
              metaGroups[meta].push(row);
            });

            // Get array of metadata groups and sort them by their most recent item
            const sortedGroups = Object.entries(metaGroups)
              .sort(([, groupA], [, groupB]) => {
                const oldestA = Math.min(...groupA.map((item) => moment.utc(item.addedAt).valueOf()));
                const oldestB = Math.min(...groupB.map((item) => moment.utc(item.addedAt).valueOf()));
                return oldestB - oldestA;
              });

            // Now process each sorted group
            sortedGroups.forEach(([, group]) => {
              // Sort items within group by addedAt descending
              group.sort((a, b) => moment.utc(b.addedAt).valueOf() - moment.utc(a.addedAt).valueOf());
              this.data = this.data.concat(group);
            });
          });

          // reset confirmed counts
          this.allScanned = {};
          // calculate total order value and client separator class flag
          for (let i = this.data.length - 1; i >= 0; i -= 1) {
            const row = this.data[i];
            this.totalPrice += (row.price * row.count);
            this.totalCount += row.count;

            // Store count vs confirmed, so we know when package is ready
            // Use composite key: metaData + date to match backend grouping
            const compositeKey = this.getCompositeKey(row);
            if (!this.allScanned[compositeKey]) {
              this.allScanned[compositeKey] = { count: row.count, confirmed: row.confirmed || 0 };
            } else {
              this.allScanned[compositeKey].count += row.count;
              this.allScanned[compositeKey].confirmed += row.confirmed || 0;
            }

            // If scanned part is on the list we do UX stuff
            if (row.ean && this.scanned.code && row.ean.includes(this.scanned.code) && row.metaData === this.scanned.order) {
              this.$toast.success(`${row.name} SCANNED FOR ${row.metaData}`);
              this.scanned.code = ''; // reset code so we don't trigger multiple toasts
              this.scannedRowIndex = i; // Set the index before scrolling
            }

            // Set border for the first item and when metaData changes
            if (i === 0) {
              this.data[i].border = true;
            } else if (
              (row.metaData
                && row.metaData.trim().toLowerCase() !== this.data[i - 1].metaData.trim().toLowerCase())
              || moment.utc(row.addedAt).format('YYYY-MM-DD') !== moment.utc(this.data[i - 1].addedAt).format('YYYY-MM-DD')
            ) {
              this.data[i].border = true;
            }
          }
        } else {
          throw new Error('No more orders to process 😴');
        }
      } catch (error) {
        this.data = [];
        if (error.response && error.response.status === 401) {
          this.$toast.warning('you\'re not authorised for this action ✋🏻');
        } else {
          this.$toast.error(error?.message);
        }
      }
      this.loading = false;
    },
    async scan() {
      if (!this.code) {
        this.$toast.error('need date and code to look for');
      } else {
        try {
          const { data } = await axios.put(
            `${fixed.API_URL}/admin/scan`, { code: this.code, local: this.scanLocal },
            { withCredentials: true },
          );
          this.scanned = { order: data.order, code: data.code };
          await this.doStuffIfScanIsFirstForTheBox();
          await this.getOrders();

          // scroll scanned article into the view
          this.$nextTick(() => {
            const rows = this.$refs.articles.querySelectorAll('tr.article-row');
            rows[this.scannedRowIndex].scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
          });

          // Play success sound
          if (this.successAudio) {
            this.successAudio.currentTime = 0;
            this.successAudio.play();
          }
        } catch (error) {
          if (error.response && error.response.status === 401) {
            this.$toast.error('you\'re not authorised for this action ✋🏻');
          } else {
            this.scanned = { order: '', code: '' };
            this.$toast.error(error?.response?.data || 'error while scanning the article');
            this.scannedRowIndex = -1;
          }
          // Play error sound
          if (this.errorAudio) {
            this.errorAudio.currentTime = 0;
            this.errorAudio.play();
          }
        }
      }
      this.code = '';
    },
    async getPackingBoxes() {
      try {
        const { data } = await axios.get(`${fixed.API_URL}/admin/pack-boxes`, { withCredentials: true });
        this.packingBoxes = data.filter((box) => !box.occupied) || [];
      } catch (error) {
        this.$toast.error(error?.response?.data || 'error while fetching packing boxes');
      }
    },
    async occupyPackingBox(box, order, oldBoxId = null) {
      if (!order.metaData || !order.addedAt) return false;

      try {
        const payload = {
          boxID: box,
          metaData: order.metaData,
          addedAt: order.addedAt,
        };

        // Add oldBoxID if provided (for reassignment)
        if (oldBoxId) {
          payload.oldBoxID = oldBoxId;
        }

        const { data } = await axios.put(
          `${fixed.API_URL}/admin/occupy-box`,
          payload,
          { withCredentials: true },
        );
        return data;
      } catch (error) {
        this.$toast.error(error?.response?.data || 'error while occupying packing box');
        return null;
      }
    },
    async doStuffIfScanIsFirstForTheBox(forAny = false) {
      if (!this.data.length || !this.scanned.order) return;
      // First we find the order items and we return if not on the page
      const order = this.data.filter((row) => row.metaData.trim() === this.scanned.order.trim());
      if (!order.length) {
        this.$toast.warning(`${this.scanned.order} is not on the list`);
        return;
      }

      // Build fresh printData every time
      const [row] = order;
      this.printData = { week: moment(row.processedAt || row.addedAt).isoWeek() };
      if (row.fromWeb && row.webUser) {
        this.printData = { ...this.printData, ...row.webUser };
        this.printData.city = row.deliveryMethod.name.startsWith('Postnord')
          ? 'POSTNORD'
          : this.cityFromDelivery(row.deliveryMethod.name);
      }
      if (row.packingBox) {
        this.printData.box = row.packingBox.boxName;
      }

      // We check if it's the first scan for this order show label otherwise return
      if (!forAny) {
        if (order.some((line) => !!line.confirmed && line.confirmed > 0)) return;

        // Store current box metadata for this order
        this.currentBoxMetadata = {
          metaData: row.metaData.trim(),
          addedAt: row.addedAt,
          currentBox: row.packingBox ? row.packingBox.boxName : null,
          currentBoxId: row.packingBox ? row.packingBox.id : null,
        };

        // Get latest packing boxes state so we can show only available ones in select
        await this.getPackingBoxes();
        // Reset selected box
        this.selectedBox = null;
        // Show box selection modal
        this.$bvModal.show('box-select-modal');
      } else {
        const iframe = clientDataSticker({ scanned: this.scanned, printData: this.printData });
        iframe.onload = () => {
          this.$nextTick(() => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
            document.body.removeChild(iframe);
          });
        };
      }
    },
    async handleBoxSelection(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault();
      // We need to select the box or use cancel to skip instead of select
      if (!this.selectedBox) {
        this.$toast.warning('Please select one of the available boxes');
        return;
      }

      try {
        // Find the order using currentBoxMetadata instead of scanned
        const orderData = {
          metaData: this.currentBoxMetadata.metaData,
          addedAt: this.currentBoxMetadata.addedAt,
        };

        // Use unified occupyPackingBox method with optional oldBoxId
        const result = await this.occupyPackingBox(
          this.selectedBox,
          orderData,
          this.currentBoxMetadata.currentBoxId,
        );

        if (result) {
          // Check if this was triggered by scanning (scanned.order will be set)
          const isFromScanning = this.scanned.order === this.currentBoxMetadata.metaData;

          if (isFromScanning) {
            // If from scanning, print label
            this.printData = { ...this.printData, box: result.boxName };
            const iframe = clientDataSticker({ scanned: this.scanned, printData: this.printData });
            iframe.onload = () => {
              this.$nextTick(() => {
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
                document.body.removeChild(iframe);
              });
            };
            // Reset scanned object so we don't trigger toast on next getOrders
            this.scanned = { order: '', code: '' };
          } else {
            // If manual assignment/change, just show success message
            const action = this.currentBoxMetadata.currentBoxId ? 'changed to' : 'assigned to';
            this.$toast.success(`Box ${action} ${result.boxName} for ${this.currentBoxMetadata.metaData}`);
          }

          await this.getOrders();
          // Hide modal
          this.$bvModal.hide('box-select-modal');
        }
      } catch (error) {
        this.$toast.error('Failed to assign box');
      }
    },
    async printLabelForAny(row) {
      // reset print data and add meta
      this.printData = { week: moment(row.processedAt || row.addedAt).isoWeek() };
      this.scanned.order = row.metaData;
      // if it's from web and, we have user data, we add extra print data
      if (row.fromWeb && row.webUser) {
        this.printData = { ...this.printData, ...row.webUser };
        this.printData.city = this.cityFromDelivery(row.deliveryMethod.name);
      }
      await this.doStuffIfScanIsFirstForTheBox(true);
    },
    cityFromDelivery(deliveryString) {
      const regex = /(?<=\d{4} )[^/]+(?= \/)/;
      const match = deliveryString.match(regex);
      return match ? match[0] : '';
    },
    handleScannerKeys(event) {
      const scanTimeout = 300; // Time in ms to consider keystrokes part of the same scan
      const currentTime = new Date().getTime();
      const timeSinceLastKey = currentTime - this.lastScanTime;

      // If there's a significant delay since the last keystroke, reset the buffer
      // This will treat this keystroke as the potential start of a new scanner sequence
      if (timeSinceLastKey > scanTimeout) {
        this.scanBuffer = '';

        // Only start a new buffer if this is an actual character
        if (event.key.length === 1) {
          this.scanBuffer = event.key;
        }
      } else if (event.key === 'Enter') {
        // Handle Enter to finalize the scan
        // Only process if we have content in the buffer
        if (this.scanBuffer && this.scanBuffer.length > 0) {
          this.code = this.scanBuffer;
          this.scanBuffer = '';

          // Process the scanned value
          this.scan();
        }

        // Prevent default behavior to avoid form submissions
        event.preventDefault();
      } else if (event.key.length === 1) {
        // Add the character to the buffer
        this.scanBuffer += event.key;
      }

      // Always update the last scan time regardless of what we did
      // This ensures we're always measuring from the last keystroke
      this.lastScanTime = currentTime;
    },
    startScanner(local = false) {
      if (!this.data.length) return;

      this.filter = null;
      this.scanner = true;
      this.scanLocal = local;

      document.addEventListener('keydown', this.handleScannerKeys);
    },
    closeScanner() {
      this.scanned = { order: '', code: '' };
      this.scanner = false;
      this.scanBuffer = '';
      this.scannedRowIndex = -1;

      document.removeEventListener('keydown', this.handleScannerKeys);
    },
    openNotes(record) {
      if (this.scanner) this.closeScanner();

      // eslint-disable-next-line no-underscore-dangle
      this.currentNotes.id = record._id;
      this.currentNotes.noteType = record.noteType || 0;
      this.currentNotes.notes = record.notes;
      this.notes = true;
    },
    closeNotes() {
      this.currentNotes.id = '';
      this.currentNotes.notes = '';
      this.notes = false;
    },
    async saveNotes() {
      if (this.currentNotes.id && this.currentNotes.notes) {
        this.loading = true;
        try {
          await axios.post(
            `${fixed.API_URL}/poland-order-comment`, this.currentNotes,
            { withCredentials: true },
          );
          await this.getOrders();
          this.$toast.success('Notes saved successfully');
        } catch (error) {
          if (error.response && error.response.status === 401) {
            this.$toast.error('you\'re not authorised for this action ✋🏻');
          } else {
            this.$toast.error('can\'t save notes for the article');
          }
        }
        this.loading = false;
      } else {
        this.$toast.warning('Note content is required');
      }

      this.currentNotes.id = '';
      this.currentNotes.notes = '';
      this.notes = false;
    },
    getBoxIdForMetadata(metaData) {
      // Find any row in the data that has the same metaData and a packingBox
      const rowWithBox = this.data.find((row) => row.metaData?.trim() === metaData?.trim() && row.packingBox?.id);
      return rowWithBox?.packingBox?.id || '';
    },
    async closePackage(fromWeb, metaData, addedAt, boxId = '') {
      if (!metaData) return;

      this.loading = true;
      try {
        const { data } = await axios.put(
          `${fixed.API_URL}/admin/close-package`,
          {
            fromWeb, metaData, addedAt, boxId,
          },
          { withCredentials: true },
        );
        // update orders lists after closing
        await this.getOrders();

        const iframe = packageSticker(data);
        iframe.onload = () => {
          this.$nextTick(() => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
            document.body.removeChild(iframe);
          });
        };
      } catch (error) {
        this.$toast.error(error?.response?.data ? error.response.data : "Can't close package");
      }
      this.loading = false;
    },
    getClassForMetadata(order) {
      if (order.orderedFor) return 'bg-dark';
      const mapped = metadataMapping.find((m) => m.pattern.test(order.metaData));
      return mapped.getClass(order?.deliveryMethod?.name);
    },
    getRowClass(row) {
      if (row.notes) {
        switch (row.noteType) {
          case 0: return 'bg-primary';
          case 1: return 'wrong-ean text-white';
          case 2: return 'unavailable-goods text-white';
          case 3: return 'goods-replaced-with text-dark';
          case 4: return 'bg-danger text-muted';

          default: return '';
        }
      }

      if (row.count === row.confirmed) return 'bg-success text-dark';
      if (row.count < row.confirmed) return 'bg-warning text-dark';
      return '';
    },
    getWeight(product) {
      if (!product?.parameters || !product.parameters.length) return 'No info';

      for (let i = 0; i < product.parameters.length; i += 1) {
        if (product.parameters[i]?.meaning && product.parameters[i].meaning === 'weight') {
          const normalizedStr = product.parameters[i].value.replace(',', '.');
          const num = parseFloat(normalizedStr);
          if (!Number.isNaN(num)) {
            return num.toFixed(2);
          }

          return 'Invalid weight';
        }
      }

      return 'No Info';
    },
    stripHtmlTags(html) {
      const div = document.createElement('div');
      div.innerHTML = html;
      return div.textContent || div.innerText || '';
    },
    allConfirmed(row) {
      // Check if all items in this metaData group (for this date) are scanned
      const key = this.getCompositeKey(row);
      return this.allScanned[key] && this.allScanned[key].count === this.allScanned[key].confirmed;
    },
    async openBoxAssignment(row) {
      if (!row.metaData) {
        this.$toast.error('Invalid order data: missing metaData');
        return;
      }

      // Get the date from the separator row to match the correct order group
      const rowDateKey = moment.utc(row.addedAt).format('YYYY-MM-DD');

      // Find the actual article rows for this metaData AND date (not the separator row)
      // This ensures we match the correct order group when same metaData exists on different dates
      const orderArticles = this.data.filter((item) => {
        if (!item.metaData) return false;
        const itemDateKey = moment.utc(item.addedAt).format('YYYY-MM-DD');
        return item.metaData.trim().toLowerCase() === row.metaData.trim().toLowerCase()
          && itemDateKey === rowDateKey;
      });

      if (!orderArticles.length) {
        this.$toast.error('No articles found for this order');
        return;
      }

      // Use the first article's addedAt timestamp (always present)
      const firstArticle = orderArticles[0];

      // Store current box metadata for this order
      this.currentBoxMetadata = {
        metaData: row.metaData.trim(),
        addedAt: firstArticle.addedAt,
        currentBox: row.packingBox ? row.packingBox.boxName : null,
        currentBoxId: row.packingBox ? row.packingBox.id : null,
      };

      // Get latest packing boxes state
      await this.getPackingBoxes();

      // Pre-select the current box if it exists
      this.selectedBox = this.currentBoxMetadata.currentBoxId;

      // Show box selection modal
      this.$bvModal.show('box-select-modal');
    },
    setFilter(f) {
      this.filter = this.filter === f ? this.filter = null : this.filter = f;
    },
  },
};
</script>

<style>
.overlay {
  position: fixed;
  margin: 0;
  padding: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  overflow: hidden;

  background-color: rgba(0, 0, 0, 0.9);
}

.scanner-input {
  height: 100vh;
}

.highlighted-row {
  background-color: #be02fd !important;
  color: #ffffff !important;
  font-size: 1.5em;
  font-weight: bold;
}

.highlighted-row td {
  color: #ffffff !important;
}

#box-select-modal .modal-dialog {
  margin-top: 50px;
}

.order-label {
  background-color: #dc3545;
  top: -21px;
}

.wrong-ean {
  background-color: #8B4513FF !important;
}
.unavailable-goods {
  background-color: #45237a !important;
}
.goods-replaced-with {
  background-color: #FFFF00FF !important;
}

.separator {
  border-top: 15px solid #222222 !important;
}

.box-action-icon {
  cursor: pointer;
  color: inherit;
  opacity: 0.7;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.box-action-icon:hover {
  opacity: 1;
  transform: scale(1.15);
}

.pulse {
  position: absolute;
  top: 35%;
  left: 40%;
  transform: translate(-505%, -50%);
  width: 100px;
  height: 100px;
  background: #33ff00;
  border: 2px solid #33ff00;
  border-radius: 50%;
  box-sizing: border-box;
  box-shadow: 0 0 0 36px #45237a;
  border-top: 2px solid #343a40 !important;
}

.pulse:before,
.pulse:after {
  content: '';
  position: absolute;
  left: -30px;
  top: -30px;
  right: -30px;
  bottom: -30px;
  border: 2px solid #33ff00;
  border-radius: 50%;
  animation: animate 2s linear infinite
}

.pulse:after {
  animation-delay: 1s;
}

@keyframes animate {
  0% {
    transform: scale(2.0);
  }

  100% {
    transform: scale(0.7);
  }
}

@keyframes pulseAnimation {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.5);
    opacity: 0.85;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.b-icon-animation-pulse {
  animation: pulseAnimation 1s infinite ease-in-out;
}
</style>
